<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.77783 0.888672H2.55561C2.08411 0.888672 1.63193 1.07597 1.29853 1.40937C0.965133 1.74277 0.777832 2.19495 0.777832 2.66645V13.3331C0.777832 13.8046 0.965133 14.2568 1.29853 14.5902C1.63193 14.9236 2.08411 15.1109 2.55561 15.1109H11.4445C11.916 15.1109 12.3682 14.9236 12.7016 14.5902C13.035 14.2568 13.2223 13.8046 13.2223 13.3331V5.33312M8.77783 0.888672L13.2223 5.33312M8.77783 0.888672V5.33312H13.2223M9.66672 9.77756H4.33339M5.22228 6.22201H4.33339"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
  defineOptions({
    name: 'InvoiceIcon',
  });
</script>
